import { Component, OnInit } from '@angular/core';

/**
 * @deprecated use tyt-plus-tag
 */
@Component({
  selector: 'app-plus-tag',
  templateUrl: './plus-tag.component.html',
  styleUrls: ['./plus-tag.component.scss']
})
export class PlusTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
